import { useRoutes } from 'react-router-dom';
import { Company, DeleteAccount, Landing, Terms } from 'features/misc';
import { publicRoutes } from './public';
import { useAuth } from 'lib/auth';
import { protectedRoutes } from './protected';

export const AppRoutes = () => {
  const auth = useAuth();

  const commonRoutes = [
    { path: '/', element: <Landing /> },
    { path: '/terms', element: <Terms /> },
    { path: '/delete-account', element: <DeleteAccount /> },
    { path: '/privacy', element: <Terms /> },
    { path: '/company', element: <Company /> },
  ];

  const routes = auth.user ? protectedRoutes : publicRoutes;

  const element = useRoutes([...routes, ...commonRoutes]);

  return <>{element}</>;
};
